import FormUtils from './FormUtils.js';
import i18n from '@/langs/i18n.js';

export default class MessagesUtils {
  static archiveTopic (topic, instance, config) {
    FormUtils.submitWithConfirm(instance, {
      endpoint: '/api/messages/topics/archive/' + topic.id,
      successTitle: i18n.t('message.topic.archiveTopicSuccessTitle'),
      successText: i18n.t('message.topic.archiveTopicSuccessTxt'),
      confirmTitle: i18n.t('message.topic.archiveTopicConfirmTitle'),
      confirmButtonText: i18n.t('message.topic.archiveTopicConfirmBtnTxt'),
      errorText: i18n.t('message.topic.archiveTopicErrorTxt'),
      successAction: () => {
        if (config && ('successAction' in config)) {
          config.successAction();
        }
      }
    });
  }

  static markAsReadTopic (topicID, instance) {
    instance.$http.post('/api/messages/topics/mark-as-read/' + topicID, {
    }).then(() => {
    }).catch((error) => {
      console.log(error);
    });
  }
}
